module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Magic-c2d8d4e0945e2781d03e64fdcfefa6f6.svg";